import React, { useState } from 'react'
import { Typography } from '@mui/material'
import Link from '@mui/material/Link'

const fileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

const Attachment = ({ attachment }) => {
  const [showAttachment, setShowAttachment] = useState(false)

  const styles = {
    root: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '8px'
    },
    icon: {
      marginRight: '8px'
    }
  }

  const extension = attachment.name?.indexOf('.') + 1 ? 
    attachment.name.split('.').pop().toLowerCase() : 
    'eml'

  const handleClick = (e) => {
    if (attachment.forceDownload) {
      e.preventDefault();
      const link = document.createElement('a');
      link.href = attachment.downloadURL;
      link.download = attachment.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  const dragProps = attachment.downloadURL ? {
    draggable: true,
    onDragStart: (e) => {
      const downloadUrl = `${attachment.contentType}:${attachment.name}:${attachment.downloadURL}`
      e.dataTransfer.setData('DownloadURL', downloadUrl)
      e.dataTransfer.setData('text/uri-list', attachment.downloadURL)
      e.dataTransfer.setData('text/plain', attachment.downloadURL)
    }
  } : {}

  return (
    <div
      style={styles.root}
      {...dragProps}
    >
      <div 
        style={styles.icon} 
        className={`fiv-size-sm fiv-viv fiv-icon-${extension}`} 
      />
      <Typography variant="body1">
        {attachment.downloadURL ? (
          <Link
            onClick={handleClick}
            color="inherit"
            href={attachment.downloadURL}
            download={attachment.forceDownload ? attachment.name : undefined}
          >
            {attachment.name || 'Email'}
          </Link>
        ) : (
          attachment.name || 'Email'
        )}
        {attachment.size ? ` (${fileSize(attachment.size)})` : ''}
      </Typography>
    </div>
  )
}

const Attachments = ({ attachments }) => {
  const styles = {
    container: {
      padding: '16px',
    }
  }

  if (!attachments || attachments.length === 0) {
    return null
  }

  return (
    <div style={styles.container}>
      {attachments.map((attachment, index) => (
        <Attachment key={`${attachment.name}-${index}`} attachment={attachment} />
      ))}
    </div>
  )
}

export default Attachments